<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">科目汇总</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="periodRange" :range="true"/>
			<div class="float-right">
				<span style="margin-right: 10px;">显示级别：1-</span>
				<select v-model.number="maxLevel" @change="onLevelChange" style="width: 120px; margin-right: 10px; padding: 4px 8px; border: 1px solid #ddd; border-radius: 4px;">
					<option v-for="item in levelOptions" :key="item.key" :value="item.key">{{item.title}}</option>
				</select>
				<Button type="primary" @click="exportData" style="margin-right: 10px;">导出</Button>
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
			</div>
		</div>
		<div class="h-panel-body" type="flex" :space-x="10">
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td colspan="2">金额合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjectId">
					<td :style="{'padding-left':(item.level)*10+'px', 'text-align':'left'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px', 'text-align':'left'}"><span class="text-hover">{{item.name}}</span></td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="4" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else-if="showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td rowspan="2" v-width="100">计量单位</td>
					<td colspan="2">金额合计</td>
					<td colspan="2">数量合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjectId">
					<td :style="{'padding-left':(item.level)*10+'px', 'text-align':'left'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px', 'text-align':'left'}"><span class="text-hover">{{item.name}}</span></td>
					<td class="text-center">{{item.unit}}</td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
					<td align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td align="right">{{item.currentCreditAmountNum|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="7" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
	import {mapState} from 'vuex'
	import {buildSubjectLevelOptions, getSubjectLevelCount} from '@/utils/subjectEncoding'
	import accountBookPeriodRange from '@/mixins/accountBookPeriodRange'

	export default {
		name: "SubjectSummary",
		mixins: [accountBookPeriodRange],
		data() {
			return {
				dataList: [],
				periodRange: {
					startDate: null,
					endDate: null
				},
				showNumPrice: false,
				loading: false,
				maxLevel: 1 // 默认选择1级
			}
		},
		computed: {
			...mapState(['currentAccountSets']),
			levelOptions() {
				return buildSubjectLevelOptions(this.currentAccountSets && this.currentAccountSets.encoding, true)
			}
		},
		watch: {
			'currentAccountSets.encoding'() {
				let maxLevel = getSubjectLevelCount(this.currentAccountSets && this.currentAccountSets.encoding)
				if (this.maxLevel > maxLevel) {
					this.maxLevel = maxLevel
				}
			},
			periodRange: {
				handler() {
					if (!this.accountBookPeriodRangeReady) {
						return;
					}
					this.loadList();
				},
				deep: true
			},
			showNumPrice() {
				this.loadList();
			},
			maxLevel() {
				this.loadList();
			}
		},
		methods: {
			onAccountBookPeriodRangeReady() {
				this.loadList();
			},
			buildRangeParams() {
				return {
					startDate: this.periodRange.startDate,
					endDate: this.periodRange.endDate
				};
			},
			onLevelChange() {
				// 确保数据类型正确
				this.maxLevel = parseInt(this.maxLevel);
				this.loadList();
			},
			loadList() {
				this.loading = true;
				this.$api.accountbook.loadSubjectSummary({
					...this.buildRangeParams(),
					showNumPrice: this.showNumPrice,
					maxLevel: this.maxLevel > 0 ? this.maxLevel : null
				}).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				})
			},

			exportData() {
				let params = {
					...this.buildRangeParams(),
					showNumPrice: this.showNumPrice,
					maxLevel: this.maxLevel > 0 ? this.maxLevel : null
				};
				window.open(`/api/accountbook/export/subjectSummary?${new URLSearchParams(params).toString()}`);
			}
		}
	}
</script>

<style scoped lang="less">
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
